<template>
  <div class="card-body">
    <router-link :to="newAdvert()" type="button" class="btn btn-primary btn-rounded">
      New Advert
    </router-link>

    <div class="my-4">
      <h4 class="card-title mb-3">Active</h4>
    </div>

    <div>
      <span>{{ notes.text }}
        <span class="ml-5 custom-link" @click="collapse = !collapse" v-show="!collapse">Read more</span>
      </span>

      <div v-show="collapse" v-for="(item, index) in notes.childrens" class="mb-4">
        <span :key="index">
          {{ `${index + 1}. ${item.title}` }}
        </span>

        <ul class="list-group" v-for="(subchild, childIndex) in item.sub_child">
          <li :key="childIndex" class="ml-4">
            {{ subchild.text }}
            <span class="ml-5 custom-link"
              v-if="index === notes.childrens.length - 1 && childIndex === item.sub_child.length - 1"
              @click="collapse = !collapse">Read less</span>
          </li>
        </ul>
      </div>
    </div>

    <hr class="mt-0 text-black" />

    <div class="table-responsive">
      <TableData :adverts="adverts" :tableId="'active_adverts'" @changeData="handleToggleStatus"
        :btnStatus="btnStatus" />
    </div>

    <hr />

    <div class="my-4">
      <h4 class="card-title mb-3">Deactivated</h4>
    </div>
    <div>
      <tableData :adverts="inactiveAdverts" :tableId="'inactive_adverts'" @changeData="handleToggleStatus"
        :btnStatus="btnStatus" />
    </div>
  </div>
</template>

<script>
import { getAdvert, toogleActiveStatus } from '../../../services/PromotionService';
import TableData from './table-data.vue';


export default {
  components: { TableData },
  data() {
    return {
      collapse: false,
      notes: {
        text: "Note: On the specified period, time, and frequency, the following will be automatically sent and displayed to all users:",
        childrens: [
          // {
          //   title: "A Push Notification.",
          //   sub_child: [
          //     { text: "No need login for push notification, However, if user happened to uninstall the app, they may not receive the push notification." }
          //   ]
          // },
          {
            title: "A popup will be displayed once only when user opens the app for the first time after the notification is sent on the day.",
            sub_child: [
              { text: "Popup type can be with link or without link." },
              { text: "If with link, the button is clickable which redirects user to the browser." },
            ]
          }
        ]
      },

      adverts: [],
      inactiveAdverts: [],
      btnStatus: false,
      loading: false
    }
  },

  watch: {
    loading: {
      handler() {
        this.$nextTick(() => {
          if (this.loading) {
            this.btnStatus = true;
          } else {
            this.btnStatus = false;
          }
        });
      },
    }
  },

  methods: {
    newAdvert() {
      return "/marketing/advert/new";
    },

    async handleToggleStatus(e) {
      this.loading = true;
      this.destroyDatatable();
      try {
        const response = await toogleActiveStatus({ id: e });
        if (response.data.success) {
          await Promise.all([
            this.fetchData(1, 'adverts'),
            this.fetchData(0, 'inactiveAdverts'),
          ]);
        }
      } catch (e) {
        console.error(e)
      }

      this.loading = false
    },

    destroyDatatable() {
      $("#active_adverts")
        .DataTable()
        .destroy();
      $("#inactive_adverts")
        .DataTable()
        .destroy();
    },

    async fetchData(status, arrayName) {
      try {
        const response = await getAdvert(status);

        if (response.data.success) {
          this[arrayName] = response.data.data;
        }
      } catch (e) {
        console.error(e);
      }
    },
  },

  async mounted() {
    await Promise.all([
      this.loading = true,
      this.fetchData(1, 'adverts'),
      this.fetchData(0, 'inactiveAdverts'),
      this.loading = false,
    ]);
  }
}
</script>

<style scoped>
.custom-link {
  text-decoration: underline !important;
  color: #AC8400;
}

.custom-link:hover {
  cursor: pointer !important;
}
</style>
